export default class DefaultController {

  constructor() {
    /**
     * @type {Backbone.View}
     */
    this.view = undefined;
  }

  init() {
    return Promise.resolve();
  }

  start() {
    return Promise.resolve();
  }

  stop() {
    return Promise.resolve();
  }

  destroy() {
    return Promise.resolve();
  }

  getViewEl() {
    return this.view ? this.view.el : undefined;
  }
}
